<template>
  <div class="article-line-card-component app-flex-row">
    <div class="image-wrapper">
      <img
        v-lazy="item.thumbnail"
        class="thumbnail"
        :alt="`微博营销 ${item.title}`"
        :title="`微博营销 ${item.title}`"
      />
    </div>
    <div class="info app-flex-rest app-flex-column-space-between font-14">
      <div class="app-flex-column">
        <span class="title font-18">{{ item.title }}</span>
        <p class="desc font-color-desc">
          {{ item.description }}
        </p>
      </div>
      <div class="bottom-info app-flex-row-space-between">
        <span class="author">作者：{{ item.author }}</span>
        <span class="time">{{
          item.release_time | relativeTimeFormat('M月D日')
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
/** 
 normal
 宽：856px 高：128px 
 image: 宽，高：128px
*/
.article-line-card-component {
  width: 100%;
  height: 128px;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 32px;
  .image-wrapper {
    width: 128px;
    height: 128px;
    overflow: hidden;
    .thumbnail {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s;
    }
  }

  .info {
    border: 1px solid $neutral-color-3;
    border-left: none;
    padding: 16px 44px 16px 32px;
    background-color: $neutral-color-1;
    height: 100%;
    overflow: hidden;
    .title,
    .desc {
      width: 100%;
      @include text-ellipsis;
    }
    .title {
      font-weight: bold;
      margin-bottom: 12px;
    }
  }
  &:hover {
    /**
    图片整体放大5%,底色色值#ffffff
     */
    .image-wrapper .thumbnail {
      transform: scale(1.05);
    }
    .info {
      background-color: $white;
    }
  }
}
</style>
